import type { StackProps } from '@hover/blueprint';
import { Body, Heading, VStack } from '@hover/blueprint';
import React from 'react';

import { Skeleton } from 'src/shared/components/Skeleton/Skeleton';

interface ProjectsHeadingProps extends StackProps {
  loading?: boolean;
  text: string;
  subText: string;
}

const ProjectsHeading = ({
  text,
  subText,
  loading,
  ...props
}: ProjectsHeadingProps) => (
  <VStack
    align="start"
    as="header"
    backgroundColor="neutral.background"
    mb="500"
    {...props}
  >
    <Heading>{text}</Heading>
    {loading ? (
      <Skeleton height="200">
        <Body>{subText}</Body>
      </Skeleton>
    ) : (
      <Body color="neutral.textLight">{subText}</Body>
    )}
  </VStack>
);

export { ProjectsHeading };
